import * as React from 'react';
import { Dispatch } from 'redux';
import { PowerBiObjectType } from '../../../types/Common/PowerBiObjectType';
import { ExportFileType } from '../../../types/Common/Enums/ExportFileType';
import { Alert, Button, Col, Container, Modal, ProgressBar, Row, Spinner } from 'react-bootstrap';
import axios, { AxiosError } from 'axios';

type FileExportDownloadModalProps = {
    dispatch: Dispatch,
    powerBiObjectType: PowerBiObjectType;
    documentId: string | undefined;
    exportFileType: ExportFileType;
    hideModal: any;
    showModal: boolean;
}

interface FileExportDownloadModalState {
    exportId: string,
    isExportInProgress: boolean,
    hasError: boolean,
    errorMessage: string,
    exportProgressPercentage: number,
    renderingStatus: ReportGenerationStatusEnum;
    downloadUrl: string,
    isDownloading: boolean,
}

enum ReportGenerationStatusEnum {
    None,
    Rendering,
    Ready,
    Error,
}

class FileExportDownloadModal extends React.Component<FileExportDownloadModalProps, FileExportDownloadModalState> {
    public constructor(props: FileExportDownloadModalProps) {
        super(props);
        this.state = {
            exportId: '',
            isExportInProgress: false,
            hasError: false,
            errorMessage: '',
            exportProgressPercentage: 0,
            renderingStatus: ReportGenerationStatusEnum.None,
            downloadUrl: '',
            isDownloading: false,
        }
    }

    private handleCloseModal() {
        this.props.hideModal();
    }

    public setError(errorMessage: string) {
        this.setState({hasError: true, isDownloading: false, isExportInProgress: false});
        this.setState({errorMessage: errorMessage});
        this.setState({renderingStatus: ReportGenerationStatusEnum.Error});
    }

    public setExportInProgress() {
        this.setState({renderingStatus: ReportGenerationStatusEnum.Rendering, isExportInProgress: true});
        this.setState({exportProgressPercentage: 5});
    }

    public setExportProgressPercentage(exportProgressPercentage: number) {
        this.setState({exportProgressPercentage: exportProgressPercentage});
    }

    public setExportFileReady(exportId: string, downloadUrl: string) {
        this.setState({isExportInProgress: false, renderingStatus: ReportGenerationStatusEnum.Ready});
        this.setState({downloadUrl: downloadUrl});
        // Click download?
        //this.downloadFile();
    }

    private handleCloseButtonClick() {
        if (this.state.isExportInProgress){
            return;
        }

        this.resetStates();
        this.handleCloseModal();
    }

    private downloadFile() {
        if (this.state.renderingStatus != ReportGenerationStatusEnum.Ready) {
            return;
        }

        this.setState({isDownloading: true});
        axios.get(this.state.downloadUrl,{
            responseType: 'blob', // Ensures the response is treated as a file
        })
        .then((response) => {
            // Extract filename from Content-Disposition header
            // Fix this:
            /*const contentDisposition = response.headers['content-disposition'];
            const filename = contentDisposition
            ? contentDisposition.split('filename=')[1]?.replace(/['"]/g, '') // Remove quotes if present
            : this.props.documentId + "." + this.props.exportFileType;

            console.log("filename: "+filename);
            console.log("split filename: "+contentDisposition.split('filename=')[1]?.replace(/['"]/g, ''));
            */
            const filename = this.props.documentId + "." + ExportFileType[this.props.exportFileType];
            console.log("filename: "+filename);

            // create file link in browser's memory
            const href = URL.createObjectURL(response.data);

            // create "a" HTML element with href to file & click
            const link = document.createElement('a');
            link.href = href;
            link.setAttribute('download', filename); //or any other extension
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);

            // Clean up and close
            this.setState({isDownloading: false});
            //this.handleCloseButtonClick();
        })
        .catch((e: AxiosError) => {
            let errorMessage = e.response?.data ? e.response?.data : e.message;
            this.setError(errorMessage);
        });
    }

    private resetStates() {
        this.setState({hasError: false, errorMessage: '', renderingStatus: ReportGenerationStatusEnum.None});
        this.setState({isExportInProgress: false, isDownloading: false});
    }


    public render() {
        return (
        <Modal size="lg" show={this.props.showModal} backdrop={this.state.isExportInProgress ? "static" : undefined} onHide={() => this.handleCloseButtonClick()}>
            <Modal.Header closeButton>
                    <Modal.Title>
                        Export {this.props.powerBiObjectType == PowerBiObjectType.Report ? "Report" : "Dashboard"} as {ExportFileType[this.props.exportFileType].toUpperCase()}
                    </Modal.Title>
                </Modal.Header>
            <Modal.Body>
                <Container>
                    <Row>
                        <Col>
                            <Alert variant='danger' show={this.state.hasError ? true : false}>
                                {this.state.errorMessage}
                            </Alert>
                        </Col>
                    </Row>
                    <Row>
                        {
                            this.state.renderingStatus == ReportGenerationStatusEnum.None ?
                                <label>Sending file export request.</label> :
                            this.state.renderingStatus == ReportGenerationStatusEnum.Rendering ?
                                <label>Your requested file is being rendered for download as {ExportFileType[this.props.exportFileType].toUpperCase()}. The process could take a few minutes depending on the size of the report.<br />Please keep this browser tab open.</label> : 
                            this.state.renderingStatus == ReportGenerationStatusEnum.Ready ?
                                <label>Your download should begin momentarily. If your download doesn't start in a moment or  you can follow this link: </label>
                            : <div></div>
                        }
                    </Row>
                    { (this.state.renderingStatus == ReportGenerationStatusEnum.Rendering || this.state.renderingStatus == ReportGenerationStatusEnum.Ready) 
                        && this.state.hasError == false ?
                        <Row style={{paddingTop: "15px"}}>
                            <Col>
                            <ProgressBar 
                                animated
                                striped
                                min={0}
                                max={100}
                                now={this.state.exportProgressPercentage}
                            />
                            </Col>
                        </Row>
                        : ""
                    }
                    { this.state.renderingStatus == ReportGenerationStatusEnum.Ready ?
                    <Row style={{justifyContent: "center", paddingTop: "15px"}}>
                        <Col
                            md={6} 
                            style={{width: "80%"}}>
                        <Button
                            active={this.state.exportProgressPercentage >= 100}
                            onClick={() => this.downloadFile()}
                            style={{width: "100%"}}
                        >
                            { this.state.isDownloading == false ? 
                                "Download" 
                                : 
                                <div style={{display: "inline-flex", verticalAlign: "center"}}>
                                <Spinner animation="border" variant="primary" role="status">
                                    <span className="sr-only">Downloading...</span>
                                </Spinner>
                                <div style={{display: "inline-flex", verticalAlign: "center"}}>Downloading...</div>
                                </div>
                            }
                        </Button>
                        </Col>
                    </Row> : ""
                    }
                    { this.state.renderingStatus == ReportGenerationStatusEnum.Error ?
                    <Row style={{justifyContent: "center", paddingTop: "15px"}}>
                        <Col
                            md={6} 
                            style={{width: "80%"}}>
                        <Button 
                            onClick={() => this.handleCloseButtonClick()}
                            style={{width: "100%"}}
                        >Close</Button> 
                        </Col> 
                    </Row>                        
                    : ""
                    }
                    
                </Container>
            </Modal.Body>
        </Modal>
        )
    }
}

export default FileExportDownloadModal;